import { render, staticRenderFns } from "./InformationRevisal.vue?vue&type=template&id=2543f770&scoped=true&"
import script from "./InformationRevisal.vue?vue&type=script&lang=js&"
export * from "./InformationRevisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543f770",
  null
  
)

export default component.exports